import React, { useEffect, useState } from "react";

import {
    Button,
    Flex,
    Loader,
    Text,
    ExcelColorIcon,
    CloseIcon,
} from "@fluentui/react-northstar";
import styled from "styled-components";
import SliderTabs from "../../../../components/shared/SliderTabs";
import { generate_tabs_offboarding } from "../../constant";

import ListCollabTable from "../ListCollabTable";
import { useMutation, useQuery } from "react-query";
import {
    _api_offboarding_user_for_export,
    _getAllOffBoardingUsersByAgency,
} from "../../api";
import { useSearchParams } from "react-router-dom";
import { DialogStyle } from "../../../../pages/DashboardTasks/style";
import { ContentExportOffboarding } from "./ContentExportOffboarding";
import { FormProvider, useForm, useWatch } from "react-hook-form";
import useToast from "../../../../hooks/useToast";
import { BASE_URL_API } from "../../../../constants";

import { _api_download_file } from "../../../../utils/fetcher";
import Toast from "../../../../components/Alerts";
import { Container, ContainerFluid } from "../../../../common/styles";
import { _get_all_employees_and_departments } from "../../../../api/user";

export default function OffboardingMainContent({
    AgencyId,
    SelectedUser,
    setSelectedUser,
}) {
    const [userToDisplayIntoTheTable, setUserToDisplayIntoTheTable] =
        useState(null);
    const [params, setParams] = useSearchParams();
    const [open_export_dialog, setOpenExportDialog] = useState(false);
    const [toastConfig, setToastConfig] = useToast();
    const param_tab = params.get("subtab");
    const [tabView, setTabView] = useState(Number(param_tab) ?? 0);

    const { data: users_by_agency, isLoading: isLoading_users_by_agency } =
        useQuery(
            ["_getAllOffBoardingUsersByAgency", AgencyId],
            () => _getAllOffBoardingUsersByAgency(AgencyId),
            {
                // enabled: AgencyId !== null,
                refetchOnWindowFocus: false,
                refetchOnMount: true,
            }
        );
    const { data: employees } = useQuery(
        ["offBoarding::GET::list_employees_and_departments_for_export"],
        () => {
            return _api_offboarding_user_for_export();
        }
    );
    const methodsExportOffboarding = useForm({
        defaultValues: {
            checkboxes_status: [],
            employee: [],
        },
    });

    const watching = useWatch({
        control: methodsExportOffboarding.control,
        exact: ["employee", "checkboxes_status"],
    });

    const { mutate: download_file, isLoading: isDownloadingExcelFile } =
        useMutation(
            ({ queryStringStatus = "", queryStringUsers = "", AgencyId }) => {
                let url = `${BASE_URL_API}/offboarding/agency/${AgencyId}/export`;

                if (queryStringUsers) {
                    url = url + "?" + queryStringUsers;
                }

                if (queryStringStatus) {
                    url = queryStringUsers
                        ? url + "&" + queryStringStatus
                        : url + "?" + queryStringStatus;
                }

                return _api_download_file({
                    url,
                    cbOnEndDownload: (data, error, message) => {
                        if (error) {
                            setToastConfig((state) => ({
                                ...state,
                                visible: true,
                                content: message
                                    ? message
                                    : "Une erreur s'est produite lors du téléchargement du fichier",
                                level: "danger",
                            }));
                            return;
                        }
                        if (data) {
                            methodsExportOffboarding.reset();
                            toggle_show_dialog(false);
                            setToastConfig((state) => ({
                                ...state,
                                visible: true,
                                content:
                                    "Votre export Excel a bien été téléchargé",
                                level: "success",
                            }));
                            return;
                        }
                    },
                });
            }
        );

    useEffect(() => {
        if (!SelectedUser) {
            setUserToDisplayIntoTheTable(null);
            setSelectedUser(null);
        }
    }, [AgencyId, setSelectedUser, SelectedUser]);

    useEffect(() => {
        if (users_by_agency && SelectedUser) {
            const user = findUserAndSetActiveTab(SelectedUser.id);
            setUserToDisplayIntoTheTable(user);
        }
    }, [users_by_agency, SelectedUser]);

    const findUserAndSetActiveTab = (userId) => {
        // Chercher dans les utilisateurs en attente de offboarding
        const waitingOffboardingUser =
            users_by_agency?.waiting_offboarding_users?.find(
                (user) => user?.id === userId
            );
        if (waitingOffboardingUser) {
            setTabView(0);
            return waitingOffboardingUser;
        }

        // Chercher dans les utilisateurs de offboarding
        const OffboardingUser = users_by_agency?.offboarding_users?.find(
            (user) => user?.id === userId
        );
        if (OffboardingUser) {
            setTabView(1);
            return OffboardingUser;
        }

        // Chercher dans les utilisateurs archivés
        const archivedUser = users_by_agency?.archived_users?.find(
            (user) => user?.id === userId
        );
        if (archivedUser) {
            setTabView(2);
            return archivedUser;
        }

        return null;
    };

    const { tabs: TABS_OFFBOARDING } =
        generate_tabs_offboarding(users_by_agency);
    const TABS_ARRAY = [
        TABS_OFFBOARDING.waiting_offboarding,
        TABS_OFFBOARDING.Offboarding,
        TABS_OFFBOARDING.Archived,
    ];

    if (isLoading_users_by_agency || !users_by_agency) {
        return <Loader label="Chargement de la page ....." />;
    }

    const toggle_show_dialog = (boolean) => {
        setOpenExportDialog(boolean);
        return;
    };

    const onDeselectUserOrDeparment = (id) => {
        return methodsExportOffboarding.setValue(
            "employee",
            methodsExportOffboarding
                .getValues("employee")
                .filter((el) => el?.id !== id)
        );
    };

    const onSubmitOffboardingExportExcel = (data) => {
        // const { tabs_array } = generate_tabs_onboarding();
        const { tabs_array } = generate_tabs_offboarding();

        const get_string_from_ids = data?.checkboxes_status.map(
            (checkbox_id) =>
                tabs_array.find((tab) => tab.id === checkbox_id)?.backend_string
        );

        const queryStringStatus = get_string_from_ids
            .map((status) => `s=${status}`)
            .join("&");

        const queryStringUsers = data?.employee
            .map((user_department) => `ud=${user_department.id}`)
            .join("&");

        download_file({ queryStringStatus, queryStringUsers, AgencyId });
        return;
    };

    return (
        <ContainerFluid>
            <Container>
                <MainContentFlex gap="gap.small" fill column>
                    <Flex fill space="between">
                        <SliderTabs
                            tabs={TABS_ARRAY.map((tab, index) => {
                                const { label, description } = tab;
                                return (
                                    <Flex
                                        key={index}
                                        styles={{
                                            gap: "8px",
                                            paddingInline: "16px",
                                            width: "100%",
                                        }}
                                        vAlign="center"
                                    >
                                        <span
                                            style={{
                                                display: "inline-block",
                                                whiteSpace: "nowrap",
                                            }}
                                            className="component"
                                        >
                                            {label}
                                        </span>
                                        {description !== null && (
                                            <SliderTabBadge
                                                color={description}
                                                content={description}
                                            />
                                        )}
                                    </Flex>
                                );
                            })}
                            onChange={(tab) => setTabView(tab)}
                            defaultActiveIndex={tabView}
                        />
                        <Toast
                            {...toastConfig}
                            onStatusChange={() =>
                                setToastConfig((state) => ({
                                    ...state,
                                    visible: false,
                                }))
                            }
                        />
                        <FormProvider {...methodsExportOffboarding}>
                            <form
                                onSubmit={methodsExportOffboarding.handleSubmit(
                                    onSubmitOffboardingExportExcel
                                )}
                            >
                                <DialogStyle
                                    open={open_export_dialog}
                                    header="Exporter les données pour Excel"
                                    confirmButton={{
                                        content: "Exporter les données",
                                        flat: true,
                                        disabled:
                                            watching.checkboxes_status
                                                .length === 0,
                                    }}
                                    onConfirm={() =>
                                        methodsExportOffboarding.handleSubmit(
                                            onSubmitOffboardingExportExcel
                                        )()
                                    }
                                    onCancel={() => toggle_show_dialog(false)}
                                    content={
                                        <ContentExportOffboarding
                                            employees={employees}
                                            onDeselectUserOrDeparment={
                                                onDeselectUserOrDeparment
                                            }
                                        />
                                    }
                                    headerAction={{
                                        icon: <CloseIcon />,
                                        onClick: () =>
                                            toggle_show_dialog(false),
                                    }}
                                    trigger={
                                        <Button
                                            icon={<ExcelColorIcon />}
                                            flat
                                            content="Exporter"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                toggle_show_dialog(true);
                                            }}
                                        />
                                    }
                                />
                            </form>
                        </FormProvider>
                    </Flex>

                    <ListCollabTable
                        users_by_agency={users_by_agency}
                        userToDisplayIntoTheTable={userToDisplayIntoTheTable}
                        activeTab={tabView}
                        AgencyId={AgencyId}
                    />
                </MainContentFlex>
            </Container>
        </ContainerFluid>
    );
}

const SliderTabBadge = styled(Text)`
    background-color: ${({ color }) => (color === 0 ? "#d1D1D1" : "#ffb900")};
    color: white;
    width: 24px;
    height: 24px;
    pointer-events: none;
    border-radius: 50%;
    padding: 6px 12px;
    font-size: 10px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const MainContentFlex = styled(Flex)`
    background: #fff;
    box-shadow: 0px 0.3px 0.9px rgba(0, 0, 0, 0.07),
        0px 1.6px 3.6px rgba(0, 0, 0, 0.11);
    padding: 24px 16px;
`;
